import "./AccessLevelListComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {useDispatch} from "react-redux";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import _ from "lodash";
import AccessLevelListTableComponent from "./access-level-list-table/AccessLevelListTableComponent";
// import {Link} from "react-router-dom";
// import {CommonService} from "../../../shared/services";
// import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
// import AddIcon from "@mui/icons-material/Add";

interface AccessLevelListComponentProps {

}

const FiltersInitialState: any = {
    search: '',
}

const AccessLevelListComponent = (props: AccessLevelListComponentProps) => {

    const dispatch = useDispatch();
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    // const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        dispatch(setCurrentNavParams("Access Level", "Access Level"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    return (
        <div className={'access-level-list-component screen'}>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Test Order"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {/*{*/}
                            {/*    commonService.checkAccess('accessLevel',*/}
                            {/*        'accessLevelAdd', currentUser?.userAccessModules) &&*/}
                            {/*    <Link to={CommonService._routeConfig.AccessRoleAddRoute()}>*/}
                            {/*        <ButtonComponent*/}
                            {/*            type="button"*/}
                            {/*            color={"primary"}*/}
                            {/*            variant={"contained"}*/}
                            {/*            id="add_access_role_button"*/}
                            {/*            startIcon={<AddIcon/>}*/}
                            {/*        >*/}
                            {/*            New Access Role*/}
                            {/*        </ButtonComponent>*/}
                            {/*    </Link>*/}
                            {/*}*/}
                        </div>
                    </div>
                    <>
                        <AccessLevelListTableComponent
                            isColumnFilterVisible={false}
                            filterData={filterData}
                        />
                    </>
                </div>
            </div>
        </div>
    );

};

export default AccessLevelListComponent;
